export default __webpack_public_path__ + "static/media/firefox.777e996c.png";